export const VALID_AUTH_REGIONS = {
  US: 'us',
  EU: 'eu',
};



// WEBPACK FOOTER //
// ./src/views/pages/Auth/constants.js